// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getBookmarkFolderTypes = contextConfiguration => axios.get(
	'/bookmark_types',
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getBookmarkFolderTypes;
